// extracted by mini-css-extract-plugin
module.exports = {"Component":"Pagination_Component__1zsSh"};